import React, { useState, useEffect} from 'react'
import axios from 'axios'
import { Alerts } from '../components/notify';
import { UserCode, config, API_URL, Contact } from '../components/Include'
import { useSelector } from 'react-redux'
import './payment.css'
import './confirmation.css'

const Confirmation = () => {
  const student = useSelector((state:any) => state.rootReducer.student)
  const [errors, setErrors] = useState({
    errorMessage: '',
    is_loading: false
  });
  
  const handleContinue = () => {
    setErrors({...errors, is_loading: true})
    let url = API_URL+'/student/steps/is_welcome/'+UserCode;
    axios.get(url, config).then(response => {
      if(response.data.status === 200) {
        // Success handling
      }
    }).catch((error) => {
      Alerts('danger', 'Error!', error.message)
    }).finally(() => {
      setErrors({...errors, is_loading: false})
      window.open('/app/skills', '_self')
    })
  }


  return (
    <>
      {errors.is_loading && (
        <div className='overlay'>
          <img src="/images/loader.svg" alt="loader" />
        </div>
      )}
      
      <div className="payment-container mt-4">
        <div className="payment-header"> 
          <h4>
            <i className="fa fa-graduation-cap me-2"></i> Welcome
          </h4>
          <ol className="breadcrumb payment-breadcrumb"> 
            <li className="breadcrumb-item"><a href="#">Home</a></li> 
            <li className="breadcrumb-item active" aria-current="page">Confirmation</li>
          </ol> 
        </div>

        <div className="confirmation-content">
      
            

            <div className="">
              <h4>Dear&nbsp;<span id="lblCandName"></span>{student.full_name}</h4>
              <p className='fs-18'>We have successfully verified your studentship and an account has been created for you. Your login details are as below:</p>

              <div className="alert alert-success">
                <p className='fs-20'>
                  <span>Matric No.: </span>
                  <b>{student.matric_no} </b> &nbsp;&nbsp;  <span> Password: </span>
                  <b>Student@1</b>
                </p>
              </div>
                       
              <p className='fs-18'>In case you are not able to finish this online form now, you can login with the above Matriculation Number and password at <a href={Contact.website}>{Contact.website}</a> and continue filling up your online form later.</p>

              <p className='fs-18'>You will need a debit card to pay the Training manual fees online</p>
                      
              <p className='fs-18'>We have sent a copy of this message to your email address as well. <br/><br/> Please endeavor to use your Matric No as reference in all your communications to us.</p>
              <p className='fs-18'>Thank You.</p>

              <form> 
                <button type='button' onClick={handleContinue} className="btn btn-primary mt-3 mb-0 btn-lg" role="button">Ok, I understand <i className='fa fa-thumbs-o-up'></i></button>
              </form>
         
          </div>
        </div>
      </div>
    </>
  )
}

export default Confirmation